(ns motorsaif.shared.ops-subs
  (:require
   [motorsaif.constants :as constants]
   [motorsaif.request-utils :as request-utils]
   [motorsaif.time :as time]
   [re-frame.core :as rf :refer [reg-sub]]
   [taoensso.encore :as encore]))

(defn last-touch-access [touches topic]
  (:touched/last-access (first (filter #(= (-> % :touched/topic) topic)
                                       (vals touches)))))

(defn unread-msgs-pred [{:keys [thread last-touch]}]
  (filter #(> (-> %
                  :message
                  :date-time/created) last-touch) (:messages thread)))

(defn thread->last-status
  [data]
  (let [{:keys [thread]} data
        is (:interaction-statuses thread)
        last-status (request-utils/last-interaction-status is)]
    last-status))

(defn thread->status
  [data]
  (let [{:keys [request]} data
        last-status (thread->last-status data)
        request-type (get-in request [:request/type :db/ident])
        options (get constants/interaction-status request-type)
        {:keys [label]} last-status
        status (first (filter #(= (:label %) label) options))]
    status))


(comment
  ;; Default filter
  ;; Deadline
  (map
   (fn [data]
     (let [last-status (thread->last-status data)
           status (thread->status data)
           max-hours (get-in status [:time :max])
           deadline (time/date-plus
                     (time/date)
                     (encore/ms :hours max-hours))]
       deadline (encore/ms :hours max-hours)))
   @(rf/subscribe [:responder-threads-with-messages])))


;; Past Deadline
;; Interaction status max time exceeds its last update

(reg-sub :ops/past-deadline
  (fn [db [_ id]]
    (filter
     (fn [data]
       (let [last-status (thread->last-status data)
             status (thread->status data)
             max-hours (get-in status [:time :max])
             id (:id status)
             last-date (:date last-status)

             deadline (when (and max-hours
                                 last-date)
                        (time/date-plus
                         last-date
                         :hours max-hours))]

         (when deadline
           (time/before? deadline (time/date)))))
     @(rf/subscribe [:responder-threads-with-messages]))))

(comment
  ;; (time/before? #inst "2025-03-13T13:37:26.746-00:00"
  ;;              (time/date)
  ;;              )

  (filter
   (fn [data]
     (let [last-status (thread->last-status data)
           status (thread->status data)
           max-hours (get-in status [:time :max])
           last-date (:date last-status)

           deadline (when last-date
                      (time/date-plus
                       last-date
                       (encore/ms :hours max-hours)))]

       (when deadline
         (time/before? deadline (time/date)))
       )


     )
   @(rf/subscribe [:responder-threads-with-messages])))

;; Urgent
;; Interaction status has less than 20% of allocated time remaining
(reg-sub :ops/urgent
  (fn [db [_ id]]
    (filter
     (fn [data]
       (let [last-status (thread->last-status data)
             status (thread->status data)
             max-hours (get-in status [:time :max])
             last-date (:date last-status)
             
             deadline (when last-date
                        (time/date-plus
                         last-date
                         (encore/ms :hours max-hours)))
             
             total-time (encore/ms :hours max-hours)
             time-remaining (when deadline
                             (- deadline (time/date)))
             urgent-threshold (* total-time 0.2)] ; 20% of total time remaining
         
         (when (and deadline time-remaining)
           (and (pos? time-remaining) ; Not past deadline yet
                (< time-remaining urgent-threshold))))) ; Less than 20% time left
     @(rf/subscribe [:responder-threads-with-messages]))))



;; Conversation Categories
;; =======================

;; Leads, no interaction status
(reg-sub :ops/leads
  (fn [db [_ id]]
    (filter
     (fn [{:keys [thread]}]
       (let [is (:interaction-statuses thread)]
         (nil? (request-utils/last-interaction-status is))))
     @(rf/subscribe [:responder-threads-with-messages]))))
(comment
  (filter
   (fn [{:keys [thread]}]
     (let [is (:interaction-statuses thread)]
       (nil? (request-utils/last-interaction-status is))))
   @(rf/subscribe [:responder-threads-with-messages])))

;; Attention, assigned is business
(reg-sub :ops/attention
  (fn [db [_ id]]
    (filter
     (fn [data]
       (let [last-status (thread->last-status data)
             status (thread->status data)
             priority (get-in status [:priority])]
         (= priority :high)))
     @(rf/subscribe [:responder-threads-with-messages]))))


(reg-sub :ops/progress
  (fn [db [_ id]]
    (filter
     #(-> (thread->status %)
          :assigned
          (= :business))
     @(rf/subscribe [:responder-threads-with-messages]))))

(reg-sub :ops/waiting
  (fn [db [_ id]]
    (filter
     #(-> (thread->status %)
          :assigned
          (= :customer))
     @(rf/subscribe [:responder-threads-with-messages]))))


(reg-sub :ops/all
  (fn [db [_ id]]
    @(rf/subscribe [:responder-threads-with-messages])
    ))

;; request-utils/last-interaction-status


(comment


  @(rf/subscribe [:all-unread-responder-messages])
  @(rf/subscribe [:all-unread-requester-messages])
  (:requester-threads @re-frame.db/app-db)
  (:responder-threads @re-frame.db/app-db)
  (:dict @re-frame.db/app-db)
  (:last-seen @re-frame.db/app-db)
  (:threads @re-frame.db/app-db))
